import { default as permissionsfcz8spkjSPMeta } from "/usr/src/app/pages/admin-settings/permissions.vue?macro=true";
import { default as tags_45settingsutMfXnfAxFMeta } from "/usr/src/app/pages/admin-settings/tags-settings.vue?macro=true";
import { default as tagsBxCCBNSbQzMeta } from "/usr/src/app/pages/admin-settings/tags.vue?macro=true";
import { default as indexUTDRdV76oIMeta } from "/usr/src/app/pages/admin-settings/unit-settings/index.vue?macro=true";
import { default as unit_45settingsKRf630ggkzMeta } from "/usr/src/app/pages/admin-settings/unit-settings.vue?macro=true";
import { default as user_45permissionsyzDI8yd71BMeta } from "/usr/src/app/pages/admin-settings/user-permissions.vue?macro=true";
import { default as usersXnEF1nfndWMeta } from "/usr/src/app/pages/admin-settings/users.vue?macro=true";
import { default as admin_45settingsQE9lZPgAJUMeta } from "/usr/src/app/pages/admin-settings.vue?macro=true";
import { default as marketing_45materialsyXMtjs15KeMeta } from "/usr/src/app/pages/content-management/marketing-materials.vue?macro=true";
import { default as news_45feedWMnPlliuVQMeta } from "/usr/src/app/pages/content-management/news-feed.vue?macro=true";
import { default as useful_45materialsjm6bP9Mf9OMeta } from "/usr/src/app/pages/content-management/useful-materials.vue?macro=true";
import { default as user_45manualsJXqZl5BNNIMeta } from "/usr/src/app/pages/content-management/user-manuals.vue?macro=true";
import { default as content_45managementNLDej6Xd1YMeta } from "/usr/src/app/pages/content-management.vue?macro=true";
import { default as createNEBqnC3eLXMeta } from "/usr/src/app/pages/create.vue?macro=true";
import { default as indexgw2ikJsyhcMeta } from "/usr/src/app/pages/index.vue?macro=true";
import { default as indexMqL0VaR3piMeta } from "/usr/src/app/pages/login/index.vue?macro=true";
import { default as all9wJxf1tOmcMeta } from "/usr/src/app/pages/properties/all.vue?macro=true";
import { default as amenitiesO3VT8yFw5xMeta } from "/usr/src/app/pages/properties/dictionaries/amenities.vue?macro=true";
import { default as developersMrrNwUMpcaMeta } from "/usr/src/app/pages/properties/dictionaries/developers.vue?macro=true";
import { default as dictionarieszeIbGJAdARMeta } from "/usr/src/app/pages/properties/dictionaries.vue?macro=true";
import { default as exclusivesusvTtFPSvfMeta } from "/usr/src/app/pages/properties/exclusives.vue?macro=true";
import { default as internal_45projectsKRnaS6HUCoMeta } from "/usr/src/app/pages/properties/internal-projects.vue?macro=true";
import { default as properties5I0VgbXTlXMeta } from "/usr/src/app/pages/properties.vue?macro=true";
import { default as _91id_93fZX8Iw32z3Meta } from "/usr/src/app/pages/property/[id].vue?macro=true";
import { default as indexyzE7Fy8zJ4Meta } from "/usr/src/app/pages/register/set-password/[hash]/index.vue?macro=true";
import { default as callback2SLl5yLrKYMeta } from "/usr/src/app/pages/sso/callback.vue?macro=true";
export default [
  {
    name: "admin-settings",
    path: "/admin-settings",
    meta: admin_45settingsQE9lZPgAJUMeta || {},
    component: () => import("/usr/src/app/pages/admin-settings.vue"),
    children: [
  {
    name: "admin-settings-permissions",
    path: "permissions",
    meta: permissionsfcz8spkjSPMeta || {},
    component: () => import("/usr/src/app/pages/admin-settings/permissions.vue")
  },
  {
    name: "admin-settings-tags-settings",
    path: "tags-settings",
    meta: tags_45settingsutMfXnfAxFMeta || {},
    component: () => import("/usr/src/app/pages/admin-settings/tags-settings.vue")
  },
  {
    name: "admin-settings-tags",
    path: "tags",
    meta: tagsBxCCBNSbQzMeta || {},
    component: () => import("/usr/src/app/pages/admin-settings/tags.vue")
  },
  {
    name: unit_45settingsKRf630ggkzMeta?.name,
    path: "unit-settings",
    meta: unit_45settingsKRf630ggkzMeta || {},
    component: () => import("/usr/src/app/pages/admin-settings/unit-settings.vue"),
    children: [
  {
    name: "admin-settings-unit-settings",
    path: "",
    component: () => import("/usr/src/app/pages/admin-settings/unit-settings/index.vue")
  }
]
  },
  {
    name: "admin-settings-user-permissions",
    path: "user-permissions",
    meta: user_45permissionsyzDI8yd71BMeta || {},
    component: () => import("/usr/src/app/pages/admin-settings/user-permissions.vue")
  },
  {
    name: "admin-settings-users",
    path: "users",
    meta: usersXnEF1nfndWMeta || {},
    component: () => import("/usr/src/app/pages/admin-settings/users.vue")
  }
]
  },
  {
    name: "content-management",
    path: "/content-management",
    meta: content_45managementNLDej6Xd1YMeta || {},
    component: () => import("/usr/src/app/pages/content-management.vue"),
    children: [
  {
    name: "content-management-marketing-materials",
    path: "marketing-materials",
    component: () => import("/usr/src/app/pages/content-management/marketing-materials.vue")
  },
  {
    name: "content-management-news-feed",
    path: "news-feed",
    component: () => import("/usr/src/app/pages/content-management/news-feed.vue")
  },
  {
    name: "content-management-useful-materials",
    path: "useful-materials",
    component: () => import("/usr/src/app/pages/content-management/useful-materials.vue")
  },
  {
    name: "content-management-user-manuals",
    path: "user-manuals",
    component: () => import("/usr/src/app/pages/content-management/user-manuals.vue")
  }
]
  },
  {
    name: "create",
    path: "/create",
    meta: createNEBqnC3eLXMeta || {},
    component: () => import("/usr/src/app/pages/create.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexgw2ikJsyhcMeta || {},
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexMqL0VaR3piMeta || {},
    component: () => import("/usr/src/app/pages/login/index.vue")
  },
  {
    name: "properties",
    path: "/properties",
    meta: properties5I0VgbXTlXMeta || {},
    component: () => import("/usr/src/app/pages/properties.vue"),
    children: [
  {
    name: "properties-all",
    path: "all",
    meta: all9wJxf1tOmcMeta || {},
    component: () => import("/usr/src/app/pages/properties/all.vue")
  },
  {
    name: "properties-dictionaries",
    path: "dictionaries",
    meta: dictionarieszeIbGJAdARMeta || {},
    component: () => import("/usr/src/app/pages/properties/dictionaries.vue"),
    children: [
  {
    name: "properties-dictionaries-amenities",
    path: "amenities",
    meta: amenitiesO3VT8yFw5xMeta || {},
    component: () => import("/usr/src/app/pages/properties/dictionaries/amenities.vue")
  },
  {
    name: "properties-dictionaries-developers",
    path: "developers",
    meta: developersMrrNwUMpcaMeta || {},
    component: () => import("/usr/src/app/pages/properties/dictionaries/developers.vue")
  }
]
  },
  {
    name: "properties-exclusives",
    path: "exclusives",
    meta: exclusivesusvTtFPSvfMeta || {},
    component: () => import("/usr/src/app/pages/properties/exclusives.vue")
  },
  {
    name: "properties-internal-projects",
    path: "internal-projects",
    meta: internal_45projectsKRnaS6HUCoMeta || {},
    component: () => import("/usr/src/app/pages/properties/internal-projects.vue")
  }
]
  },
  {
    name: "property-id",
    path: "/property/:id()",
    meta: _91id_93fZX8Iw32z3Meta || {},
    component: () => import("/usr/src/app/pages/property/[id].vue")
  },
  {
    name: "register-set-password-hash",
    path: "/register/set-password/:hash()",
    meta: indexyzE7Fy8zJ4Meta || {},
    component: () => import("/usr/src/app/pages/register/set-password/[hash]/index.vue")
  },
  {
    name: "sso-callback",
    path: "/sso/callback",
    meta: callback2SLl5yLrKYMeta || {},
    component: () => import("/usr/src/app/pages/sso/callback.vue")
  }
]